<template>
  <ActionsDropdown
    :menu="actions"
    class="no-hover text-13-400"
    color="primary"
    dropdown-icon="expand_more"
  >
    <template #label>
      <q-img
        class="flag"
        :src="flag"
      />
    </template>
  </ActionsDropdown>
</template>

<script>
import GM_FLAG from 'common/assets/flags/German.svg';
import UK_FLAG from 'common/assets/flags/UK.svg';
import ActionsDropdown from 'common/components/ActionsDropdown';
import handleError from 'common/helpers/handleError';
import { mapActions, mapGetters, mapState } from 'vuex';

const flags = {
  de_DE: GM_FLAG,
  en_EN: UK_FLAG,
};

export default {
  name: 'LanguageSelector',
  components: { ActionsDropdown },
  computed: {
    ...mapState('app', ['layout', 'account']),
    ...mapGetters('app', ['defaultLanguage']),
    flag() {
      return flags[this.current];
    },
    current() {
      return this.account?.currentLanguage || this.$i18n.locale || this.defaultLanguage;
    },
    actions() {
      return this.layout?.availableLanguages?.map((lang) => ({
        title: lang.label,
        img: flags[lang.locale],
        disable: this.current === lang.locale,
        handler: () => this.changeLanguage(lang.locale),
      })) || [];
    },
  },
  methods: {
    ...mapActions('app', ['updateIdentity']),
    async changeLanguage(locale) {
      try {
        this.$q.loading.show();
        if (this.account) {
          await this.updateIdentity({
            firstName: this.account.firstName,
            lastName: this.account.lastName,
            locale,
          });
        } else {
          this.$i18n.locale = locale;
        }
      } catch (error) {
        handleError(error);
      } finally {
        this.$q.loading.hide();
      }
    },
  },
};
</script>

<style scoped>

.flag {
  width: 26px;
}
</style>
